/**
 * Settings' sub-nav and the section beside it — `screens.md` §10, Phase 5 plan Q-P7.
 *
 * Four sections, in the mock's order. A section with `to: null` has no screen yet and renders
 * as a pending row: `acceptance-tests.md`, *"no unbuilt destination is omitted from the nav"*.
 */
import type { ReactNode } from "react";
import { Link, Outlet } from "@tanstack/react-router";

import { pendingTreatment } from "../shell/pending.js";
import { PendingRow } from "../shell/PendingRow.js";

import "./settings.css";

export interface SettingsSection {
  readonly label: string;
  readonly to: "/settings/organisation" | "/settings/team" | "/settings/billing" | null;
}

export const SETTINGS_SECTIONS: readonly SettingsSection[] = [
  { label: "Organisation", to: "/settings/organisation" },
  { label: "Team & roles", to: "/settings/team" },
  { label: "API keys", to: null },
  { label: "Billing & usage", to: "/settings/billing" },
];

export function SettingsLayout(): ReactNode {
  const treatment = pendingTreatment(
    SETTINGS_SECTIONS.filter((section) => section.to === null).length,
  );

  return (
    <div className="pp-settings-layout">
      <nav className="pp-subnav" aria-label="Settings sections">
        <div className="pp-subnav__heading">Settings</div>
        {SETTINGS_SECTIONS.map((section) =>
          section.to === null ? (
            <PendingRow key={section.label} label={section.label} treatment={treatment} />
          ) : (
            <Link
              key={section.to}
              to={section.to}
              activeProps={{ "data-active": "true" }}
            >
              <span>{section.label}</span>
            </Link>
          ),
        )}
      </nav>
      <div className="pp-settings-layout__main">
        <Outlet />
      </div>
    </div>
  );
}
